import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../../components/common/Typography';
import SlideRightDialog from '../../../components/common/SlideRightDialog';
import Button from '../../../components/common/Button';

const Description = ({ isOpen, onClose, title, description, handleSubCheckboxChange2 }) => {
  const { t } = useTranslation('terms');
  const { t: tCommon } = useTranslation('common');
  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose} title={t('myInfoTitle')}>
      <div className="displayFlexColumn" style={{ gap: '10px', paddingBottom: '70px' }}>
        <Typography className="body1Bold">{title}</Typography>
        <Typography className="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
      </div>
      {/* <div className="button_container">
        <Button value={t('button2')} fullWidth onClick={() => handleSubCheckboxChange2(isOpen)} />
      </div> */}
    </SlideRightDialog>
  );
};

export default Description;
